export default __webpack_public_path__ + "static/media/ic_read.ac3b1ef6.svg";